import {Component, Input, ViewChild} from "@angular/core";
import {EditGridComponent} from "../../../framework/entity/edit/edit-grid/edit-grid.component";
import {EntityData, field, ReportModel} from "@fedeltapointofsale/data-client";
import {AccountSearchPageComponent} from "../account-search-page/account-search-page.component";

export class AccountReportSelectionControlData extends EntityData<AccountReportSelectionControlData> {
    @field accountName: string;
    @field accountNo: string;
    @field accountId: number;
}

@Component({
    selector: "wbo-account-report-selection",
    templateUrl: "./account-report-selection-control.component.html"
})
export class AccountReportSelectionControlComponent {

    AccountSearchPageComponent = AccountSearchPageComponent;

    fieldName: string = "accounts";

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    constructor(public model: ReportModel<any>) {
    }

    addFromAccount(data: any[]): void {
        data.forEach((item) => {
            if (!this.model.data[this.fieldName].find((accountData: any) => accountData.accountId === item.accountId)) {
                const index: number = this.editGridComponent.addRow(item) - 1;
            }
        });
    }
}
